import React from 'react';
import {menuContextDefaultValue, TreeViewContext} from '../context';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {useSelector} from 'react-redux';
import {pageSelectors} from 'features/layout/CommonPage/redux';
import {packId} from 'common/diplomatIdUtil';

/**
 * Check client/tree/DiplomatTreeMenu.java
 */
export const useBuildHeaderMenuContext = ({handleClose}: {handleClose: (ev?: any) => void}) => {
   const [data, setData] = React.useState<INav>();

   const values = useSelector(pageSelectors.getData);
   React.useEffect(
      () =>
         setData({
            ...values,
            _id: values._id || values.id,
            id: packId(values.objectType, values.id),
         } as INav),
      [values, setData]
   );

   const contextValue = React.useMemo(
      () =>
         ({
            ...menuContextDefaultValue,
            data,
            handleClose,
         } as TreeViewContext),
      [data, handleClose]
   );

   return {
      contextValue,
   };
};
